module.exports = __webpack_public_path__ + "media/WR Blob 3.e056185d.mp3";